import Image from "next/image";
import { Inter } from "next/font/google";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import HeroComponent from "@/components/Home/Hero/HeroComponent";
import ContainerLayout from "@/components/Layout/ContainerLayout";
import WhatComponent from "./What/WhatComponent";
import StepsComponent from "./Steps/StepsComponent";
import ExplainComponent from "./Explain/ExplainComponent";
import PricingComponent from "./Pricing/PricingComponent";
import NumbersComponent from "./Numbers/NumbersComponent";
import ContactComponent from "./Contact/ContactComponent";

const inter = Inter({ subsets: ["latin"] });

export default function HomeComponent() {
    return (
        <div>
            <ContainerLayout containerId="hero">
                <HeroComponent />
            </ContainerLayout>
            <ContainerLayout containerId="">
                <ExplainComponent />
            </ContainerLayout>
            <ContainerLayout containerId="steps">
                <StepsComponent />
            </ContainerLayout>
            <ContainerLayout containerId="what">
                <WhatComponent />
            </ContainerLayout>
            <ContainerLayout containerId="pricing">
                <PricingComponent />
            </ContainerLayout>
            <ContainerLayout containerId="hero">
                <NumbersComponent />
            </ContainerLayout>
            <ContainerLayout containerId="contact">
                <ContactComponent />
            </ContainerLayout>
        </div>
    );
}
